'use client'

import { SiteShell } from '@/components/site/site-shell'
import { WorkSection } from '@/components/site/work-section'

export default function PortfolioPage() {
  return (
    <SiteShell>
      <div className="pt-20" />
      <WorkSection mode="full" />
    </SiteShell>
  )
}
